const Bun = () => {
  return (
    <section className="bun-type">
      <br />
      <label for="bun">
        <strong>What type of bun would you like?</strong>
      </label>
      <br />
      <br />
      <select name="bun">
        <option value="sesame">Sesame</option>
        <option value="potato">Potato</option>
        <option value="brioche">Brioche</option>
        <option value="wheat">Wheat</option>
        <option value="white">White</option>
        <option value="focaccia">Focaccia</option>
        <option value="italian">Italian</option>
        <option value="multigrain">Multigrain</option>
        <option value="pretzel">Pretzel</option>
      </select>
      <br />
      <br />
    </section>
  );
};

export default Bun;
